export default class TimeOutError extends Error {
  constructor(timeoutInSeconds: number) {
    super(`Client timed out connecting to host after ${timeoutInSeconds} seconds`);
  }
}
